import React from 'react';
import Modal from '@material-ui/core/Modal';
import styles from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { firestore } from '../../../fire';
// eslint-disable-next-line no-unused-vars
import _ from 'lodash';
import { Button } from '@material-ui/core';
import WLTableHeadingRow from './components/WLTableHeadingRow';
import WLTableCells from './components/WLTableCells';

const WatchListAdd = ({
  latestPrice,
  handleClickSnak,
  showModal,
  isMobile,
  watchListModalIndex,
  date,
  setShowModal,
  symbol,
  userData,
}) => {
  const MakeWatchListData = () => {
    const arrayToSend = watchListModalIndex.map((data) => {
      const newData = {
        Expiry: data.expiry,
        Price: data.theo_ask,
        PutCall: data.put_call,
        RR: data.RR,
        Stock: latestPrice,
        Strike: data.strike,
        date: date,
        symbol: symbol,
      };
      return newData;
    });
    return arrayToSend;
  };
  const AddtoFav = async () => {
    const user = userData.sub;
    const concatedUser = `felix${user}`;
    const check = await firestore
      .collection('favourite')
      .doc(concatedUser)
      .collection('data')
      .get();
    let WatchListData = MakeWatchListData();
    let oldLength = WatchListData.length;

    let newArray = check.docs.map((doc) => {
      let data = doc.data();

      return data;
    });

    const tempArray = newArray.map((inc) => {
      return {
        Expiry: inc.Expiry,
        PutCall: inc.PutCall,
        Strike: inc.Strike,
        symbol: inc.symbol,
      };
    });
    WatchListData = WatchListData.filter(
      (result) =>
        !tempArray.find((obj) => {
          return (
            obj.Expiry === result.Expiry &&
            obj.PutCall === result.PutCall &&
            obj.Strike === result.Strike &&
            obj.symbol === result.symbol
          );
        })
    );

    WatchListData.map(async (data) => {
      await firestore
        .collection('favourite')
        .doc(concatedUser)
        .collection('data')
        .add(data);
    });
    let DuplicateEntries = oldLength - WatchListData.length;
    handleClickSnak(DuplicateEntries, WatchListData.length);
  };
  return (
    <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <div
          style={
            isMobile
              ? styles.ToolTipboardModalContentWatchListModalMobile
              : styles.ToolTipboardModalContentWatchListModal
          }
        >
          <div
            onClick={() => setShowModal(false)}
            style={
              !isMobile
                ? { ...styles.modalCloseButton, marginTop: '2px' }
                : { ...styles.modalCloseButtonMobile, marginTop: '2px' }
            }
          >
            X
          </div>

          <div style={{ ...styles.ModalTable, width: '90%' }}>
            <div style={styles.AreYouSureText}>
              <div>
                Are you sure that you want to add this to your WatchList?
              </div>
            </div>
            <Table style={{ tableLayout: isMobile ? 'fixed' : '' }}>
              <WLTableHeadingRow styles={styles} isMobile={isMobile} />
              <TableBody>
                {watchListModalIndex &&
                  watchListModalIndex.map((row, index) => {
                    return (
                      <WLTableCells
                        key={index}
                        row={row}
                        mykey={index}
                        styles={styles}
                        date={date}
                        latestPrice={latestPrice}
                        symbol={symbol}
                      />
                    );
                  })}
              </TableBody>
            </Table>

            <div style={styles.AreYouSureText}>
              <Button
                id="btnGO"
                variant="contained"
                style={{
                  ...styles.goButton,
                  minWidth: '22px',
                  maxWidth: '22px',
                  marginTop: '8px',
                  height: '26px',
                  backgroundColor: 'darkgrey',
                  color: 'black',
                  border: '1px solid',
                  fontSize: '12px',
                }}
                onClick={() => {
                  AddtoFav();
                }}
              >
                Go
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WatchListAdd;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListAdd/index.js